import React from "react";
import { Form, Modal, Alert, Input } from "antd";
import { useRequest } from "ahooks";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { getRequiredRule } from "@/util/formValidatorRules";
import { applyChannelShopEwaybillAuth } from "@/services/api/ewaybillAuth";

interface ChannelShopAuthModalProps extends InjectBaseModalProps {}

const ChannelShopAuthModal: React.FC<ChannelShopAuthModalProps> = React.memo(function (props) {
  const { visible, onCancel } = props;

  const [form] = Form.useForm<{ ewaybillShopSellerUsername: string }>();

  const { run, loading } = useRequest(
    async () => {
      const values = await form.validateFields();

      const ewaybillShopSellerUsername = values.ewaybillShopSellerUsername?.trim?.();

      await applyChannelShopEwaybillAuth(ewaybillShopSellerUsername);

      Modal.success({
        title: "已发起申请",
        content: (
          <div className="text-error">
            <div className="mb10">请在10分钟内联系店铺：{ewaybillShopSellerUsername} 登录发货易去同意申请</div>

            <div>超过10分钟该申请作废，需要重新发起</div>
          </div>
        ),
      });

      onCancel();
    },
    {
      manual: true,
    }
  );

  return (
    <Modal
      width={720}
      visible={visible}
      onCancel={onCancel}
      title="授权使用视频号电子面单"
      okText="去申请"
      onOk={run}
      confirmLoading={loading}
    >
      <Alert
        className="mb10"
        message={
          <div>
            <p>温馨提示：</p>

            <p>
              1 授权使用视频号电子面单，需要填写对方视频号小店的账号
              <a href="https://qw15p3s8hv.feishu.cn/wiki/DRotwAEm5ijWzukTdG5cSk2GnYb" target="_blank" className="ml5">
                点击查看在发货易内获取视频号小店账号教程
              </a>
            </p>
            <p>
              2 共享视频号电子面单使用视频号电子面单授权方式，申请后需要联系对方店铺及时登录发货易内同意申请
              <a
                href="https://qw15p3s8hv.feishu.cn/wiki/Mea8w3cQLiClKXkMO0rcfQtLnhf?from=from_copylink"
                target="_blank"
                className="ml5"
              >
                点击查看共享视频号电子面单申请授权教程
              </a>
            </p>
          </div>
        }
        type="warning"
      />

      <Form form={form}>
        <Form.Item
          extra="视频号小店账号一般以wx开头"
          label="已开通电子面单的小店账号"
          name="ewaybillShopSellerUsername"
          rules={[getRequiredRule("店铺账号必须填写")]}
        >
          <Input placeholder="请输入店铺账号" />
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default ChannelShopAuthModal;
